/** `AI` module valdiators unique keys */
export enum AIValidatorsEnum {
  AGENT_ASSERT_EXISTS_BY_ID = 'ai/agent::assert-exists-by-id',
  /** Check that agent with identifier in that DTO exists */
  AGENT_ASSERT_EXISTS_BY_DTO = 'ai/agent::assert-exists-by-dto',
}
